import { defineMessages } from 'react-intl';

export const LegalDocLabelByCountryCode: Record<
  string,
  {
    uploadLegalDoc: { id: string; defaultMessage: string };
    legalNumber: { id: string; defaultMessage: string };
    legalNumberPlaceholder: { id: string; defaultMessage: string };
  }
> = {
  MY: defineMessages({
    uploadLegalDoc: {
      id: 'text-upload-company-legal-doc-my',
      defaultMessage: 'Upload Suruhanjaya Syarikat Malaysia (SSM)',
    },
    legalNumber: {
      id: 'text-company-legal-number-my',
      defaultMessage: 'Business Registration Number (BRN) ',
    },
    legalNumberPlaceholder: {
      id: 'text-placeholder-company-legal-number-my',
      defaultMessage: 'Please enter your Business Registration Number (BRN)',
    },
  }),
  default: defineMessages({
    uploadLegalDoc: {
      id: 'text-upload-company-legal-doc-default',
      defaultMessage: 'Upload your Company Legal Document',
    },
    legalNumber: {
      id: 'text-company-legal-number-default',
      defaultMessage: 'Company Legal Number',
    },
    legalNumberPlaceholder: {
      id: 'text-placeholder-company-legal-number-default',
      defaultMessage: 'Please enter your Company Legal Number',
    },
  }),
};
